import React from 'react';

import styles from './FondBlanc.module.scss';

const FontGris = () => <span className={[styles.FondGris].join(' ')} />;

export default FontGris;
